import React from 'react';
import Table from '@views/adminMonitoring/table/Table'

const AdminMonitoring = () => {
	return (
		<div>
			<h2>주간 등록 모니터링</h2>
			<Table />
		</div>
	)
}

export default AdminMonitoring